module.exports = __webpack_public_path__ + "static/media/play-button.e1c848fe.png";